"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _neptune = require("./neptune");

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require("./_n");

var _n3 = _interopRequireDefault(_n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.brig = {

  focusable: 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="search"]:not([disabled]), select:not([disabled]), [tabindex]',

  init: function init(p) {
    p = p || document;

    _n3.default.qsa("[neptune-brig]", p).forEach(function (el) {

      if (!!el.brig) return false;

      var _brig = {};

      try {
        _brig = USON.parse(el.getAttribute("neptune-brig").replace(/'/g, '"').replace(/`/g, "'").replace(/</g, "[").replace(/>/g, "]"), "array")[0];
      } catch (error) {
        _brig = {};
      }

      _brig.keys = _n3.default.array(_brig.keys) || ["Tab", 9];
      _brig.targets = !!_brig.targets ? _n3.default.array(_brig.targets) : _neptune2.default.brig.focusable;
      _brig.method = _brig.method || "focus";
      _brig.event = _brig.event || "keyup";

      el.addEventListener(_brig.event, function (e) {
        if ((_brig.keys.includes(e.key) || _brig.keys.includes(e.keyCode)) && (document.activeElement == el || el.contains(document.activeElement) && document.activeElement.matches(_brig.targets))) {
          var action = false;
          if (e.keyCode == 9) action = "next";
          if (e.keyCode == 39) action = "next";
          if (e.keyCode == 40) action = "next";
          if (e.shiftKey && e.keyCode == 9) action = "prev";
          if (e.keyCode == 37) action = "prev";
          if (e.keyCode == 38) action = "prev";

          // alert(action);
          _brig.target_elements = _n3.default.array(_n3.default.qsa(_brig.targets, el));
          _brig.currentIndex = _brig.target_elements.indexOf(document.activeElement);
          // console.log(_brig.currentIndex);
          // console.log(action);

          if (action == "next") {
            e.preventDefault();
            if (_brig.currentIndex == _brig.target_elements.length - 1) {
              _brig.target_elements[0].focus();
            } else {
              console.log(_brig.target_elements[_brig.currentIndex + 1]);
              _brig.target_elements[_brig.currentIndex + 1].focus();
              console.log(_brig.currentIndex + 1);
            }
          }
          if (action == "prev") {
            e.preventDefault();
            if (_brig.currentIndex == [0]) {
              _brig.target_elements[_brig.target_elements.length - 1].focus();
            } else {
              _brig.target_elements[_brig.currentIndex - 1].focus();
            }
          }
        }
        return true;
      });

      el.brig = _brig;
    });
  },

  setTabbable: function setTabbable(element, isTabbable) {
    // Set the tabindex of an element and any of its children
    var setTab = function setTab(el) {
      if (isTabbable) {
        el.setAttribute('tabindex', 0);
      } else {
        el.setAttribute('tabindex', -1);
      }
    };

    setTab(element);

    _n3.default.qsa(_neptune2.default.brig.focusable, element).forEach(function (focusableElement) {
      setTab(focusableElement);
    });
  }
};

window.Neptune = _neptune2.default;

exports.default = _neptune2.default.brig;